import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './theme/global-style';
import { unregister } from './registerServiceWorker'
import App from './App';
import { isMaintenanceMode } from './lib/config'
import { Maintenance } from './components/Maintenance'

const node = isMaintenanceMode ? <Maintenance /> : <Router>
    <App history={history} />
  </Router>

ReactDOM.render(node, document.getElementById('root'));

unregister();



// WEBPACK FOOTER //
// ./src/index.tsx